import {
  ADD_CHIT_STARTED,
  ADD_CHIT_COMPLETED,
  ADD_CHIT_ERROR,
  FETCH_CHITS_STARTED,
  FETCH_CHITS_COMPLETED,
  FETCH_CHITS_ERROR
} from '../actionTypes/chitActionTypes';

const INITIAL_STATE = {
  submitted: false,
  success: false,
  error: false,
  chits: {}
};

function chitReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ADD_CHIT_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case ADD_CHIT_COMPLETED: {
      return {
        ...state,
        submitted: false,
        success: true
      };
    }
    case ADD_CHIT_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    case FETCH_CHITS_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case FETCH_CHITS_COMPLETED: {
      if (action.payLoad) {
        return {
          ...state,
          chits: { ...action.payLoad },
          submitted: false,
          success: true
        };
      } else {
        return {
          ...state,
          submitted: false,
          success: true
        };
      }
    }
    case FETCH_CHITS_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    default:
      return state;
  }
}

export default chitReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/chitReducer.js